import type { RecordOfMatchEntity } from '../betting/betting-entities';
import { SportId } from '../betting/constants';
import { BasketballPeriods } from './Basketball';
import { getBasketballPeriodsValue } from './Basketball/get-basketball-periods-value';
import { ESportsPeriods } from './ESports';
import { HandballPeriods } from './Handball';
import { getHandballPeriodsValue } from './Handball/get-handball-periods-value';
import { IceHockeyPeriods } from './IceHockey';
import { getIceHockeyPeriodsValue } from './IceHockey/get-ice-hockey-period-value';
import { SoccerPeriods } from './Soccer';
import { getSoccerPeriodsValue } from './Soccer/get-soccer-periods-value';
import { TableTennisPeriods } from './TableTennis';
import { TennisPeriods } from './Tennis';
import { TennisTieBreakTypes } from './Tennis/constants';
import { getTennisPeriodsValue } from './Tennis/get-tennis-period-value';
import { VolleyballPeriods } from './Volleyball';

export function getPeriodsBySport(
  periods?: RecordOfMatchEntity['periods'],
  sportId?: SportId,
  scores?: RecordOfMatchEntity['scores'] | null,
  tieBreak?: TennisTieBreakTypes | null,
){
  if (!sportId) {
    return;
  }
  switch (sportId) {
    case SportId.VOLLEYBALL: {
      return VolleyballPeriods(sportId, periods).value;
    }
    case SportId.BASKETBALL: {
      if (!scores) {
        return null;
      }

      const { value } = BasketballPeriods(sportId, periods, scores);

      return getBasketballPeriodsValue(value);
    }
    case SportId.E_SPORT: {
      return ESportsPeriods(sportId, periods).value;
    }
    case SportId.HANDBALL: {
      const { value } = HandballPeriods(sportId, periods);

      return getHandballPeriodsValue(value);
    }
    case SportId.TABLE_TENNIS: {
      return TableTennisPeriods(sportId, periods).value;
    }
    case SportId.SOCCER: {
      const { value } = SoccerPeriods(sportId, periods);

      return getSoccerPeriodsValue(value);
    }
    case SportId.TENNIS: {
      const { value } = TennisPeriods(sportId, periods, tieBreak);

      if (typeof value !== 'string') {
        return getTennisPeriodsValue(value);
      }
      return value;
    }
    case SportId.ICE_HOCKEY: {
      const { value } =  IceHockeyPeriods(sportId, periods);

      return getIceHockeyPeriodsValue(value);
    }
    case SportId.DOTA: {
      const { value } =  ESportsPeriods(sportId, periods);

      return value;
    }
    case SportId.CS_GO: {
      const { value } =  ESportsPeriods(sportId, periods);

      return value;
    }

    case SportId.BOXING_AND_MMA:
    case SportId.HOCKEY_WITH_BALL:
    case SportId.FIELD_HOCKEY:
    case SportId.BEACH_VOLLEYBALL:
    case SportId.WATER_POLO:
    case SportId.BADMINTON:
    case SportId.FUTSAL: {
      return null;
    }
    default: assertExhaustiveness(sportId);
      return null;
  }
}

